import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import VueTimers from 'vue-timers'
import * as ModalDialogs from 'vue-modal-dialogs'
import { BasePlugin, ExtraPlugin } from 'stylemix-base'
import 'vue-select/dist/vue-select.css'
import * as fields from '../components/fields'
import * as values from '../components/values'
import ImgField from '../components/fields/ImgField'

Vue.use(VueTimers)
Vue.use(BasePlugin, {
  defaultLayout: 'horizontal',
  repeaterRemoveLabel: '',
  repeaterRemoveIcon: 'icon-cross3',
})
const vue_app_gm = config.VUE_APP_GOOGLE_MAP_KEY
  ? config.VUE_APP_GOOGLE_MAP_KEY
  : process.env.VUE_APP_GOOGLE_MAP_KEY
Vue.use(ExtraPlugin, {
  googleKey: vue_app_gm,
  dateTimeDisplayFormat: 'ddd, MMM Do YYYY - HH:mm:ss',
  timeTwelveFormat: false,
})

// Register field components
Object.keys(fields).forEach(component => {
  Vue.component(`Form${component}`, fields[component])
})

// Register value components
Object.keys(values).forEach(component => {
  Vue.component(component, values[component])
})

Vue.use(Vue2Filters)

Vue.use(ModalDialogs)

Vue.component('FormImgField', ImgField)

Vue.prototype.$dateFormat = 'ddd, MMMM Do YYYY - HH:mm:ss'
